export default "__VITE_ASSET__aa3e724d__"